exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".spinnerContainer{position:absolute;top:50%;left:50%;width:20px;height:20px;margin-left:-10px;margin-top:-10px}.circle{border-width:2px}", ""]);

